import { useDareRequirementMessages, } from 'root/src/client/logic/dropEvent/hooks/useDareRequirementMessages';
// import Link from 'root/src/client/web/base/Link'
// import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls'
export function RequirementDareMessages() {
    const daresMessages = useDareRequirementMessages();
    return (<div className="m-[30px] text-center">
			{daresMessages.map(message => <p key={message} className="font-bold text-lg">{message}</p>)}
			{/* <p className="font-bold text-lg">See your data on the <Link href={routeUrls.creatorDashboard()}>dashboard</Link></p> */}
		</div>);
}
